const SAVE_COMPANY_INFO_DATA_START = 'SAVE_COMPANY_INFO_DATA_START';
const SAVE_COMPANY_INFO_DATA_SUCCESS = 'SAVE_COMPANY_INFO_DATA_SUCCESS';
const SAVE_COMPANY_INFO_DATA_ERROR = 'SAVE_COMPANY_INFO_DATA_ERROR';
const SAVE_COMPANY_INFO_DATA_RESET = 'SAVE_COMPANY_INFO_DATA_RESET';
const GET_COMPANY_INFO_DATA_START = 'GET_COMPANY_INFO_DATA_START';
const GET_COMPANY_INFO_DATA_SUCCESS = 'GET_COMPANY_INFO_DATA_SUCCESS';
const GET_COMPANY_INFO_DATA_ERROR = 'GET_COMPANY_INFO_DATA_ERROR';
const PUT_COMPANY_INFO_LOADING = 'PUT_COMPANY_INFO_LOADING';
const PUT_COMPANY_INFO_DATA = 'PUT_COMPANY_INFO_DATA';

const setCompanyInfoStart = (payload, companyId) => {
	return {
		type: SAVE_COMPANY_INFO_DATA_START,
		payload,
		companyId,
	};
};

const setCompanyInfoSuccess = (res = null) => {
	return {
		type: SAVE_COMPANY_INFO_DATA_SUCCESS,
		res,
	};
};

const setCompanyInfoError = () => {
	return {
		type: SAVE_COMPANY_INFO_DATA_ERROR,
	};
};
const setCompanyInfoReset = () => {
	return {
		type: SAVE_COMPANY_INFO_DATA_RESET,
	};
};

const getCompanyInfoStart = (companyId) => {
	return {
		type: GET_COMPANY_INFO_DATA_START,
		companyId,
	};
};

const getCompanyInfoSuccess = (res) => {
	return {
		type: GET_COMPANY_INFO_DATA_SUCCESS,
		res,
	};
};

const getCompanyInfoError = () => {
	return {
		type: GET_COMPANY_INFO_DATA_ERROR,
	};
};

const putCompanyInfo = (payload, extras) => {
	return {
		type: PUT_COMPANY_INFO_DATA,
		payload,
		extras,
	};
};

export default {
	types: {
		SAVE_COMPANY_INFO_DATA_START,
		SAVE_COMPANY_INFO_DATA_SUCCESS,
		SAVE_COMPANY_INFO_DATA_ERROR,
		SAVE_COMPANY_INFO_DATA_RESET,
		GET_COMPANY_INFO_DATA_START,
		GET_COMPANY_INFO_DATA_SUCCESS,
		GET_COMPANY_INFO_DATA_ERROR,
		PUT_COMPANY_INFO_LOADING,
		PUT_COMPANY_INFO_DATA,
	},
	creators: {
		setCompanyInfoStart,
		setCompanyInfoSuccess,
		setCompanyInfoError,
		setCompanyInfoReset,
		getCompanyInfoStart,
		getCompanyInfoSuccess,
		getCompanyInfoError,
		putCompanyInfo,
	},
};
